import { AboutActionTypes } from './actionTypes';

const initialState = {
  news: null,
  loading: {
    news: false,
  },
  error: {
    news: null,
  },
};

export const AboutReducer = (state = initialState, action) => {
  const { type, payload, error } = action;
  switch (type) {
    case AboutActionTypes.NEWS.FETCH:
      return {
        ...state,
        loading: { ...state.loading, news: true },
        error: { ...state.error, news: null },
      };
    case AboutActionTypes.NEWS.SUCCESS:
      return {
        ...state,
        news: payload,
        loading: { ...state.loading, news: false },
      };
    case AboutActionTypes.NEWS.FAILURE:
      return {
        ...state,
        loading: { ...state.loading, news: false },
        error: { ...state.error, news: error },
      };

    default:
      return state;
  }
};
